import { NewChatApi } from "../../types";
import { usePost } from "../usePost";
import { NEW_CHAT_API_PATH } from "../../constants";
import { jsonSerializer } from "../../utils";

export const usePostNewChat = () => {
  return usePost({
    url: NEW_CHAT_API_PATH,
    serializer: jsonSerializer((data: NewChatApi) => data.chat_id),
  });
};
